module.exports = __webpack_public_path__ + "c158df4baef0d35c5ad33f3b42ad2f6a.png";